import { HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { NgProgressInterceptor, NgProgress } from "ngx-progressbar";

@Injectable()
export class ProgressInterceptor extends NgProgressInterceptor {

    silentApis = ['msg/'];

    constructor(ngProgress: NgProgress) {
        super(ngProgress);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Ignore silent api requests
        if (this.checkUrl(req)) {
            return next.handle(req);
        }

        return super.intercept(req, next);
    }

    /**
     * Check if request is silent.
     * @param req request
     */
    private checkUrl(req: HttpRequest<any>) {
        const url = req.url.toLowerCase();
        const found = this.silentApis.find((u) => url.includes(u));
        return !!found;
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/interceptor/progress-interceptor.ts